<template>
  <div>
    <div class="card-row card-row-show">
      <div class="card-row-col card-col w150">
        {{invoice.invoice_number}}
      </div>
      <div class="card-row-col card-col w150">
        <span class="invoice-row" :class="getStatusStyle(invoice.status)">
          {{statusLabel(invoice.status)}}
        </span>
      </div>
      <div class="card-row-col card-col w150">
        {{invoice.created_at | moment("DD MMM YYYY") }}
      </div>
      <div class="card-row-col card-col w200">
        {{ (invoice.status >= 3) ? invoice.client_amount : invoice.transporter_amount}} INR
      </div>
      <div class="card-row-col card-col w200">
      </div>
      <div class="card-row-col card-col w100">
      </div>
      <div class="card-row-col card-col payment-actions">
        <div class="isadded action">
        <Popover placement="bottom-end" v-model="comment">
          <div class="popover-primary">
            <div class="popover-primary-header">
              <h3>Comments</h3>
              <span class="remove-icon" @click="comment=false">
                <svgicon name="cancel" width="10" height="10" :original="true" />
              </span>
            </div>
            <div class="popover-primary-body">
              <Comments
                :showForm="commentLoading"
                :comments="comments"
                v-on:addComment="addComment"/>
            </div>
          </div>
          <div @click="loadComments()" slot="reference">
            <svgicon name="Comments" width="14" height="14" :original="true" />
            Comments
          </div>
        </Popover>
      </div>
        <div class="isadded" v-if="isCreditAdded">
          <div class="addnote" v-if="showNote">

            <Popover placement="bottom-end" v-model="showRevision">
        <div class="popover-primary">
          <div class="popover-primary-body">
            Amount : {{invoice.revision.value}}
          </div>
        </div>
        <div slot="reference">
          <svgicon name="debitnote" width="15" height="15" :original="true" />
            <span>{{invoice.revision.number}}</span>
        </div>
      </Popover>
          </div>
          <div class="addnote" v-else>
            <Popover popper-class="medium-width" placement="bottom-end" v-model="lrNumber">
              <div class="popover-primary">
                <div class="popover-primary-header">
                  <h3>ADD CREDIT NOTE</h3>
                  <span class="remove-icon" @click="lrNumber=false">
                    <svgicon name="cancel" width="10" height="10" :original="true" />
                  </span>
                </div>
                <div class="popover-primary-body">
                  <div v-if="errorNoteNumber" class="error-text">
                    Enter note number
                  </div>
                  <div v-if="errorAmount" class="error-text">
                    Enter amount
                  </div>
                  <div class="form-fields">
                    <div class="input-line">
                      <div class="label">CREDIT NOTE NUMBER</div>
                      <input type="text" v-model.trim.lazy="noteno">
                    </div>
                    <div class="input-line input-line-amount">
                      <div class="label">AMOUNT</div>
                      <div class="amount">INR {{getDifferenceAmount}}</div>
                      <!-- <input type="number" v-model.trim.lazy="amount"> -->
                    </div>
                    <div class="submit-button">
                      <button class="btn btn-primary" @click="addCreditNoteClick">
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div slot="reference">
                <svgicon name="creditnote" width="15" height="15" :original="true" />
                <span>NOTE</span>
              </div>
            </Popover>
          </div>
        </div>
        <div class="table-td-cursor details-action" @click="getDetails">
          <svgicon name="arrow-down" width="12" height="12" :original="true" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import status from '@/constants/invoice-status';
import Comments from '@/components/common/comments';

export default {

  props: {
    invoice: {
      type: Object,
    },
    commentLoading: Boolean,
    comments: Array,
  },
  components: {
    Comments,
  },
  data() {
    return {
      lrNumber: false,
      showRevision: false,
      noteno: '',
      amount: 0,
      errorNoteNumber: false,
      errorAmount: false,
      comment: false,
    };
  },

  computed: {
    isCreditAdded() {
      let createdNoteEnabled = false;
      if (this.invoice.transporter_revision) {
        createdNoteEnabled = true;
      }
      if(this.invoice.revision.number) {
         createdNoteEnabled = true;
      }
      return createdNoteEnabled;
    },
    getDifferenceAmount() {
      const amount = (this.invoice.transporter_amount - this.invoice.client_amount);
      this.amount =  (amount < 0) ? 0 : amount.toFixed(2);
      return this.amount;
    },
    showNote() {
      return this.invoice.revision && this.invoice.revision.number;
    },
  },

  methods: {
    getStatusStyle(id) {
      const name = this.getStatus(id);
      return `status-${name ? name.name : '-invoice'}`;
    },
    getStatus(id) {
      return status.find(i => i.ids.includes(id));
    },
    statusLabel(id) {
      const stas = this.getStatus(id);
      return stas ? stas.label : 'Invoice';
    },
    clickNote() {
      this.$store.showInvoice = true;
      this.$store.invoiceId = this.invoice.id;
      this.$store.invoice = this.invoice;
      this.$router.push({ name: 'ShowNote' });
    },
    getDetails() {
      this.$store.showInvoice = true;
      this.$store.showTax = true;
      this.$store.showNote = false;
      this.$store.invoiceId = this.invoice.id;
      this.$store.invoice = this.invoice;
      this.$router.push({ name: 'OrderDetail' });
    },
    async addCreditNoteClick() {
      this.errorNoteNumber = !Boolean(this.noteno);
      this.errorAmount = !Boolean(this.amount) || this.amount <= 0;
      if (!this.errorNoteNumber && !this.errorAmount) {
        const result = await this.$store.dispatch('payment/createnote', {
          clientId: this.invoice.client_id,
          invoiceId: this.invoice.id,
          number: this.noteno,
          value: this.amount,
        });
        if (result) {
          this.invoice.revision = result;
          this.$success({
            message: `Credit Note Added for ${this.invoice.invoice_number}`,
          });
        } else {
          this.$error({
            message: `Add note credit note failed`,
          });
        }
      }
    },
    addComment(comment) {
      this.$emit('addConversation', { comment, id: this.invoice.id, section: 2 });
    },
    loadComments() {
      this.$emit('getComments', { id: this.invoice.id, section: 2 });
    },
  },
};
</script>

<style lang="scss" scoped>
.invoice-row {
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
  padding-bottom: 5px;
  border-radius: 2px;
}
.status {
  &-pending {
    border: 0.5px solid #E48F00;
    color: #E48F00;
  }
  &-re_submitted {
    border: 0.5px solid #62A360;
    color: #62A360;
  }
  &-accepted {
    border: 0.5px solid #62A360;
    color: #62A360;
  }
  &-rejected {
    border: 0.5px solid #FF6666;
    color: #FF6666;
  }
  &-processing {
    border: 0.5px solid #404040;
    color: #404040;
  }
  &-paid {
    border: 0.5px solid #62A360;
    color: #62A360;
  }
}

.status-invoice {
  border: 0.5px solid #E48F00;
  color: #E48F00;
}

.table-td-cursor svg {
  transform: rotate(-90deg);
}
.details-action {
  display: inline-block;
}
.addnote {
  display: inline-block;
  margin-left: 20px;
  margin-right: 20px;
  color: #376F99;
  cursor: pointer;
}
input {
  border-color: transparent;
  background-color: transparent;
  outline: none;
  border-bottom: 1px solid #DEE5E6;
}
.medium-width {
  width: 400px !important;
}
.popover-primary-body {
  padding-top: 20px;
  padding-bottom: 5px;
}
.label {
  color: #646464;
  font-size: 10px;
  line-height: 12px;
  margin-bottom: 2px;
  margin-top: 2px;
}
.input-line {
  padding-top: 5px;
  &-amount {
    padding-top: 15px;
  }
}
.submit-button {
  margin-top: 30px;
  button {

  }
}
.error-text  {
  margin-top: 0;
}
.isadded {
  display: inline-block;
  cursor: pointer;
}
.payment-actions {
    width: calc(100% - 950px);
    text-align: right;
    .action{
          color: #376F99;
          text-transform: uppercase;
    }
}
</style>
